export default [
	{
		name: 'Frogs Hollow',
		ID: 1,
	},
	{
		name: 'Motorbike Frog',
		ID: 2,
	},
	{
		name: 'Bottlenose Dolphin',
		ID: 3,
	},
	{
		name: 'Blue Swimmer Crab',
		ID: 4,
	},
	{
		name: 'Quokka',
		ID: 5,
	},
];
